import { useMemo, useState } from 'react';
import { useDifferiments } from '../../../../hooks/useDifferiments';
import { useDifferimentDetail } from '../../../../hooks/useDifferimentPayments';

export const useDifferimentsTable = () => {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [selectedContract, setSelectedContract] = useState(null);
  const [selectedPaymentContract, setSelectedPaymentContract] = useState(null);

  const { data = [], isLoading, isFetching, refetch, isError } = useDifferiments({}, { enabled: true });
  const detailQuery = useDifferimentDetail(selectedContract);
  const paymentDetailQuery = useDifferimentDetail(selectedPaymentContract);

  const handleFetch = () => {
    refetch();
  };

  const filteredData = useMemo(() => {
    if (!Array.isArray(data)) return [];
    const term = search.toLowerCase().trim();
    if (!term) return data;
    return data.filter((item) => item.contract_number?.toLowerCase().includes(term));
  }, [data, search]);

  const totalCount = filteredData.length;
  const totalPages = Math.max(1, Math.ceil(totalCount / rowsPerPage));
  const currentPage = Math.min(page, totalPages);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (_, value) => {
    setPage(value);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(Number(event.target.value));
    setPage(1);
  };

  const openDetail = (uuid_contract) => {
    if (!uuid_contract) return;
    setSelectedContract(uuid_contract);
  };

  const closeDetail = () => {
    setSelectedContract(null);
  };

  const openPayments = (uuid_contract) => {
    if (!uuid_contract) return;
    setSelectedPaymentContract(uuid_contract);
  };

  const closePayments = () => {
    setSelectedPaymentContract(null);
  };

  return {
    search,
    setSearch,
    data: paginatedData,
    totalCount,
    totalPages,
    page: currentPage,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
    isLoading,
    isFetching,
    isError,
    handleFetch,
    openDetail,
    closeDetail,
    selectedContract,
    detailQuery,
    openPayments,
    closePayments,
    selectedPaymentContract,
    paymentDetailQuery,
  };
};

export default useDifferimentsTable;
